<template>
  <div class="modules-wrapper">
    <div :class="'module-' + module.type" v-for="module in modules">
      <div class="module-paragraph-wrapper">
        <Module :module="module" :type="module.type" />
      </div>
    </div>
  </div>
</template>

<script>
  import Module from '@/components/Module.vue';

  export default {
    name: 'Modules',

    props: ['modules'],

    data() {
      return {
        loading: true,
      }
    },

    components: {
      Module,
    }
  }
</script>
